enum ApplicationState {
    Loading = 1,
    Loaded,
    Error,
}

export default ApplicationState;
